import { EventObject, Typestate } from 'xstate';
import { CustomerEligibility, LeaseItem, SelectLeaseOptionErrors, SendVerificationTokenError, UpdateDebitErrors } from '../../gql/graphql';
import { CustomerLookupEvents } from './customerLookupMachine.types';
import { OrderIdMachineContext } from './shared/context/orderIdMachineContext';
import { OrderMachineContext } from './shared/context/orderMachineContext';
import { CartItemModel } from './existingApplicationMachine.types';
import { RoleMachineContext } from './shared/context/roleMachineContext';

// Context Types
export interface EntryPointMachineContext extends RoleMachineContext, OrderIdMachineContext, OrderMachineContext {
  authorizeCardErrors: UpdateDebitErrors[];
  page: string;
  entrypointParam?: string;
  entrypointSessionId?: string;
  cellPhone?: string;
  sendCodeErrors: SendVerificationTokenError[];
  highestSupportedApplicationMilestone: number;
  leaseSigned: boolean;
  loanSigned: boolean;
  eligibilityDetails?: CustomerEligibility; // TODO: big todo for OTB, where does this come from

  didSkipOTP: boolean;

  selectLeaseOptionErrors?: SelectLeaseOptionErrors[];
  cart: CartItemModel[];
  applicationItems: LeaseItem[]; // for m4 bandaid

  selectedLeaseTerm?: string; // comes from the selectLeaseOption resp. This is NOT defaulted to the selectedLeaseTerm application property
}

// State Types
export enum EntryPointStates {
  ApprovalConfirmation = 'ApprovalConfirmation',
  Initial = 'EntryPointInitial',
  OTPVerification = 'OTPVerification',
  OTPRequest = 'OTPRequest',
  PreApproval = 'PreApproval',
  ContractSummaryLoading = 'ContractSummaryLoading',
  ContractSummary = 'ContractSummary',
  BankAccountError = 'BankAccountError',
  DebitCardError = 'DebitCardError',
  LoanDeclined = 'LoanDeclined',
  LeaseDeclined = 'LeaseDeclined',
  LeaseSigned = 'LeaseSigned',
  Done = 'Done',
  Prequalification = 'Prequalification',
}

export interface EntryPointMachineStatesSchema {
  [EntryPointStates.ApprovalConfirmation]: {};
  [EntryPointStates.OTPVerification]: {};
  [EntryPointStates.OTPRequest]: {};
  [EntryPointStates.PreApproval]: {};
  [EntryPointStates.ContractSummary]: {};
  [EntryPointStates.LeaseDeclined]: {};
  [EntryPointStates.LoanDeclined]: {};
  [EntryPointStates.Done]: {};
  [EntryPointStates.Prequalification]: {};
  [EntryPointStates.ContractSummaryLoading]: {};
}

export interface EntryPointMachineStates extends Typestate<EntryPointMachineContext> {
  type: EntryPointMachineStatesSchema;
}

// Event Types
export enum EntryPointEvents {
  NEXT = 'NEXT',
  BACK = 'BACK',
  EDIT_DEBIT_INFO = 'EDIT_DEBIT_INFO',
  APPROVED = 'Approved',
  DECLINED_OR_ERROR = 'DeclinedOrError',
  COMPLETE_APP_LATER = 'CompleteAppLater',
  TRACK = 'TRACK',
  PAGE = 'PAGE',
  IDENTIFY = 'IDENTIFY',
  SKIP_OTP = 'SKIP_OTP',
  SEND_TOKEN = 'SEND_TOKEN',
}

type EntryPointEventsTypeSchema =
  | EntryPointEvents.NEXT
  | EntryPointEvents.BACK
  | EntryPointEvents.EDIT_DEBIT_INFO
  | EntryPointEvents.APPROVED
  | EntryPointEvents.DECLINED_OR_ERROR
  | EntryPointEvents.COMPLETE_APP_LATER
  | CustomerLookupEvents.SEND_TOKEN
  | CustomerLookupEvents.TRACK
  | CustomerLookupEvents.PAGE
  | CustomerLookupEvents.IDENTIFY
  | EntryPointEvents.SKIP_OTP
  | EntryPointEvents.SEND_TOKEN;

export interface EntryPointMachineEvents extends EventObject {
  type: EntryPointEventsTypeSchema;
  data?: any;
}
